import service1 from '../assets/images/services/service1.png';
import service2 from '../assets/images/services/service2.png';
import service3 from '../assets/images/services/service3.png';
import service4 from '../assets/images/services/service4.png';
import service5 from '../assets/images/services/service5.png';
import service6 from '../assets/images/services/service6.png';

//Laptop Serice
import laptopRepairBanner from '../assets/images/services/service1/banner.png'
import laptopOffer1 from '../assets/images/services/service1/offers/offer1.png';
import laptopOffer2 from '../assets/images/services/service1/offers/offer2.png';
import laptopOffer3 from '../assets/images/services/service1/offers/offer3.png';
import laptopOffer4 from '../assets/images/services/service1/offers/offer4.png';
import laptopOffer5 from '../assets/images/services/service1/offers/offer5.png';
import laptopPersonImage from '../assets/images/services/service1/person.png';
import laptopIcon1 from '../assets/images/services/service1/icon1.png';
import laptopIcon2 from '../assets/images/services/service1/icon2.png';
import laptopIcon3 from '../assets/images/services/service1/icon3.png';
import laptopIcon4 from '../assets/images/services/service1/icon4.png';


//Support Serice
import supportRepairBanner from '../assets/images/services/service3/banner.png'
import supportOffer1 from '../assets/images/services/service3/offers/offer1.png';
import supportOffer2 from '../assets/images/services/service3/offers/offer2.png';
import supportOffer3 from '../assets/images/services/service3/offers/offer3.png';
import supportOffer4 from '../assets/images/services/service3/offers/offer4.png';
import supportOffer5 from '../assets/images/services/service3/offers/offer5.png';
import supportPersonImage from '../assets/images/services/service3/person.png';
import supportIcon1 from '../assets/images/services/service3/icon1.png';
import supportIcon2 from '../assets/images/services/service3/icon2.png';
import supportIcon3 from '../assets/images/services/service3/icon3.png';
import supportIcon4 from '../assets/images/services/service3/icon4.png';

//Support Serice
import phoneRepairBanner from '../assets/images/services/service2/banner.png'
import phoneOffer1 from '../assets/images/services/service2/offers/offer1.png';
import phoneOffer2 from '../assets/images/services/service2/offers/offer2.png';
import phoneOffer3 from '../assets/images/services/service2/offers/offer3.png';
import phoneOffer4 from '../assets/images/services/service2/offers/offer4.png';
import phoneOffer5 from '../assets/images/services/service2/offers/offer5.png';
import phoneOffer6 from '../assets/images/services/service2/offers/offer6.png';
import phonePersonImage from '../assets/images/services/service2/person.png';
import phoneIcon1 from '../assets/images/services/service2/icon1.png';
import phoneIcon2 from '../assets/images/services/service2/icon2.png';
import phoneIcon3 from '../assets/images/services/service2/icon3.png';
import phoneIcon4 from '../assets/images/services/service2/icon4.png';

//Coachig Serice
import coachRepairBanner from '../assets/images/services/service4/banner.png'
import coachOffer1 from '../assets/images/services/service4/offers/offer1.png';
import coachOffer2 from '../assets/images/services/service4/offers/offer2.png';
import coachOffer3 from '../assets/images/services/service4/offers/offer3.png';
import coachOffer4 from '../assets/images/services/service4/offers/offer4.png';
import coachOffer5 from '../assets/images/services/service4/offers/offer5.png';
import coachPersonImage from '../assets/images/services/service4/person.png';
import coachIcon1 from '../assets/images/services/service4/icon1.png';
import coachIcon2 from '../assets/images/services/service4/icon2.png';
import coachIcon3 from '../assets/images/services/service4/icon3.png';
import coachIcon4 from '../assets/images/services/service4/icon4.png';

//Tennies Serice
import tennisRepairBanner from '../assets/images/services/service5/banner.png'
import tennisOffer1 from '../assets/images/services/service5/offers/offer1.png';
import tennisOffer2 from '../assets/images/services/service5/offers/offer2.png';
import tennisOffer3 from '../assets/images/services/service5/offers/offer3.png';
import tennisOffer4 from '../assets/images/services/service5/offers/offer4.png';
import tennisOffer5 from '../assets/images/services/service5/offers/offer5.png';
import tennisPersonImage from '../assets/images/services/service5/person.png';
import tennisIcon1 from '../assets/images/services/service5/icon1.png';
import tennisIcon2 from '../assets/images/services/service5/icon2.png';
import tennisIcon3 from '../assets/images/services/service5/icon3.png';
import tennisIcon4 from '../assets/images/services/service5/icon4.png';

//Watch Serice
import watchRepairBanner from '../assets/images/services/service6/banner.png'
import watchOffer1 from '../assets/images/services/service6/offers/offer1.png';
import watchOffer2 from '../assets/images/services/service6/offers/offer2.png';
import watchOffer3 from '../assets/images/services/service6/offers/offer3.png';
import watchOffer4 from '../assets/images/services/service6/offers/offer4.png';
import watchOffer5 from '../assets/images/services/service6/offers/offer5.png';
import watchPersonImage from '../assets/images/services/service6/person.png';
import watchIcon1 from '../assets/images/services/service6/icon1.png';
import watchIcon2 from '../assets/images/services/service6/icon2.png';
import watchIcon3 from '../assets/images/services/service6/icon3.png';
import watchIcon4 from '../assets/images/services/service6/icon4.png';

export const servicesData = {
    "phone-repair-service": {
        "page_title": "Smartphone Repair Service",
        "banner_image": phoneRepairBanner,
        "full_description": "We fix everything from cracked screens to battery issues, keeping you connected without delay.",
        "offer_description": "We repair all major smartphone brands — from cracked screens to battery issues — with precision and care. Trust us to make your phone feel like new.",
        "offers": [
            { "image": phoneOffer1, "title": "Screen Replacement", "description": "Fast, high-quality screen replacements for cracked or damaged displays." },
            { "image": phoneOffer2, "title": "Battery Replacement", "description": "Fast, high-quality screen replacements for cracked or damaged displays." },
            { "image": phoneOffer3, "title": "Charging Port Repairs", "description": "Fixing charging issues for reliable power-ups." },
            { "image": phoneOffer4, "title": "Water Damage Repair", "description": "Reviving phones affected by accidental water spills." },
            { "image": phoneOffer5, "title": "Software Fixes", "description": "Solving slow performance, freezing, and other software-related issues." },
            { "image": phoneOffer6, "title": "Camera & Audio Repairs", "description": "Restoring your phone’s camera, speaker, and microphone functionality." },
        ],
        "process_steps": [
            { "title": "Diagnosis", "description": "We assess your device thoroughly." },
            { "title": "Quote", "description": "You get a transparent, no-surprise estimate." },
            { "title": "Repair", "description": "We fix it fast and right." },
            { "title": "QC & Return", "description": "Every repair is tested and guaranteed." }
        ],
        "personImage": phonePersonImage,
        "why_choose": [
            { "icon": phoneIcon1, "title": "Certified Technicians", "description": "Experienced professionals ensuring quality service." },
            { "icon": phoneIcon2, "title": "Genuine Parts", "description": "Use of authentic components for durability." },
            { "icon": phoneIcon3, "title": "Quick Turnaround", "description": "Efficient service delivery without compromising quality." },
            { "icon": phoneIcon4, "title": "1 Month Warranty", "description": "Peace of mind with our service guarantee." },
        ],
        "title": "Phone Repair Services",
        "short_description": "Quick fixes for screens, batteries, and more — get your phone working like new.",
        "image": service1,
        "link": "/services/phone-repair-service"
    },
    "laptop-repair-services": {
        "page_title": "Laptop Repair Service",
        "banner_image": laptopRepairBanner,
        "full_description": "From hardware issues to software glitches, we bring your laptop back to life swiftly and efficiently.",
        "offer_description": "We handle a wide range of laptop issues across all major brands, ensuring your device functions optimally.",
        "offers": [
            { "image": laptopOffer1, "title": "Screen Replacement", "description": "Fixing cracked or malfunctioning displays with precision." },
            { "image": laptopOffer2, "title": "Battery Replacement", "description": "Replacing old or faulty batteries to restore portability." },
            { "image": laptopOffer3, "title": "Keyboard & Touchpad Repairs", "description": "Resolving unresponsive or damaged input devices." },
            { "image": laptopOffer4, "title": "Hard Drive & SSD Upgrades", "description": "Enhancing storage capacity and speed." },
            { "image": laptopOffer5, "title": "Software Troubleshooting", "description": "Addressing operating system errors and software conflicts." },
        ],
        "process_steps": [
            { "title": "Diagnosis", "description": "We assess your device thoroughly." },
            { "title": "Quote", "description": "You get a transparent, no-surprise estimate." },
            { "title": "Repair", "description": "We fix it fast and right." },
            { "title": "QC & Return", "description": "Every repair is tested and guaranteed." }
        ],
        "personImage": laptopPersonImage,
        "why_choose": [
            { "icon": laptopIcon1, "title": "Certified Technicians", "description": "Experienced professionals ensuring quality service." },
            { "icon": laptopIcon2, "title": "Genuine Parts", "description": "Use of authentic components for durability." },
            { "icon": laptopIcon3, "title": "Quick Turnaround", "description": "Efficient service delivery without compromising quality." },
            { "icon": laptopIcon4, "title": "1 Month Warranty", "description": "Peace of mind with our service guarantee." },
        ],
        "title": "Laptop Repair Services",
        "short_description": "Hardware and software solutions to bring your laptop back to life.",
        "image": service2,
        "link": "/services/laptop-repair-services"
    },
    "watch-repair-service": {
        "page_title": "Watch and Jewellery Repair & Servicing Restoring Timepieces to Perfection",
        "banner_image": watchRepairBanner,
        "full_description": "Expert care for your cherished watches, ensuring precision and longevity.",
        "offer_description": "Comprehensive watch repair and maintenance services.",
        "offers": [
            { "image": watchOffer1, "title": "Battery Replacement", "description": "Quick and reliable battery changes." },
            { "image": watchOffer2, "title": "Strap & Bracelet Adjustments", "description": "Ensuring a perfect fit for your wrist." },
            { "image": watchOffer3, "title": "Movement Overhaul", "description": "Detailed servicing for mechanical and automatic watches." },
            { "image": watchOffer4, "title": "Crystal Replacement", "description": "Replacing damaged or scratched watch crystals." },
            { "image": watchOffer5, "title": "Water Resistance Testing", "description": "Ensuring your watch is sealed and protected." },
        ],
        "process_steps": [
            { "title": "Inspection", "description": "Assessing the watch to identify issues." },
            { "title": "Quotation", "description": "Providing a detailed estimate for the required services." },
            { "title": "Repair", "description": "Skilled technicians perform the necessary repairs." },
            { "title": "Quality Assurance", "description": "Final checks to ensure optimal performance." }
        ],
        "personImage": watchPersonImage,
        "why_choose": [
            { "icon": watchIcon1, "title": "Experienced Watchmakers", "description": "Professionals with expertise in various watch brands." },
            { "icon": watchIcon2, "title": "Genuine Parts", "description": "Use of authentic components for durability." },
            { "icon": watchIcon3, "title": "Timely Service", "description": "Efficient turnaround times for all repairs." },
            { "icon": watchIcon4, "title": "Customer Trust", "description": "Building long-term relationships through quality service." },
        ],
        "title": "Watch and Jewellery Repair",
        "short_description": "Professional care for your watches — from battery changes to full servicing.",
        "image": service6,
        "link": "/services/watch-repair-service"
    },
    "home-tech-support": {
        "page_title": "Home Tech Support Reliable Assistance at Your Fingertips",
        "banner_image": supportRepairBanner,
        "full_description": "From Wi-Fi issues to smart device setups, we ensure your home technology runs smoothly.",
        "offer_description": "We provide comprehensive tech support services to address all your home technology needs.",
        "offers": [
            { "image": supportOffer1, "title": "Wi-Fi & Network Setup", "description": "Ensuring strong and secure internet connectivity throughout your home." },
            { "image": supportOffer2, "title": "Smart Device Configuration", "description": "Setting up and integrating smart home devices for seamless operation." },
            { "image": supportOffer3, "title": "Computer & support Troubleshooting", "description": "Resolving software issues and optimizing performance." },
            { "image": supportOffer4, "title": "Printer & Peripheral Setup", "description": "Installing and configuring printers, scanners, and other devices." },
            { "image": supportOffer5, "title": "Data Backup & Recovery", "description": "Protecting your important files and recovering lost data." },
        ],
        "process_steps": [
            { "title": "Assessment", "description": "Understanding your tech issues through a detailed consultation." },
            { "title": "Quotation", "description": "Providing a clear estimate with no hidden charges." },
            { "title": "On-Site Support", "description": "Our experts visit your home to resolve the issues efficiently." },
            { "title": "Post-Service Check", "description": "Ensuring everything functions perfectly before we leave." }
        ],
        "personImage": supportPersonImage,
        "why_choose": [
            { "icon": supportIcon1, "title": "Experienced Technicians", "description": "Skilled professionals with extensive tech support experience." },
            { "icon": supportIcon2, "title": "Prompt Service", "description": "Quick response times to address your urgent needs" },
            { "icon": supportIcon3, "title": "Comprehensive Solutions", "description": "Handling a wide range of home tech issues." },
            { "icon": supportIcon4, "title": "Customer Satisfaction", "description": "Commitment to ensuring you're fully satisfied with our service." },
        ],

        "title": "Home Tech Support",
        "short_description": "On-site help for setting up and troubleshooting your home devices.",
        "image": service3,
        "link": "/services/home-tech-support"
    },
    "computer-coaching-service": {
        "page_title": "Computer Coaching Empowering You with Digital Skills",
        "banner_image": coachRepairBanner,
        "full_description": "From basic operations to advanced applications, we guide you every step of the way.",
        "offer_description": "Personalized coaching sessions tailored to your learning pace and goals.",
        "offers": [
            { "image": coachOffer1, "title": "Basic Computer Skills", "description": "Understanding operating systems, file management, and internet browsing." },
            { "image": coachOffer2, "title": "Office Applications Training", "description": "Mastering Word, Excel, PowerPoint, and more." },
            { "image": coachOffer3, "title": "Email & Communication Tools", "description": "Setting up and effectively using email and messaging platforms." },
            { "image": coachOffer4, "title": "Cybersecurity Awareness", "description": "Learning to protect your data and privacy online." },
            { "image": coachOffer5, "title": "Customized Learning Plans", "description": "Focusing on specific skills you wish to develop." },
        ],
        "process_steps": [
            { "title": "Initial Consultation", "description": "Assessing your current skill level and objectives." },
            { "title": "Customized Plan", "description": "Developing a learning path tailored to your needs." },
            { "title": "Interactive Sessions", "description": "Engaging lessons with practical exercises." },
            { "title": "Progress Evaluation", "description": "Regular assessments to track improvement." }
        ],
        "personImage": coachPersonImage,
        "why_choose": [
            { "icon": coachIcon1, "title": "Experienced Instructors", "description": "Professionals with a passion for teaching technology." },
            { "icon": coachIcon2, "title": "Flexible Scheduling", "description": "Sessions arranged at times convenient for you." },
            { "icon": coachIcon3, "title": "Supportive Environment", "description": "Encouraging learning atmosphere to boost confidence." },
            { "icon": coachIcon4, "title": "Resource Materials", "description": "Providing guides and materials for continued learning." },
        ],
        "title": "Computer Coaching",
        "short_description": "One-on-one sessions to build your tech confidence and skills.",
        "image": service4,
        "link": "/services/computer-coaching-service"
    },
    "tennis-coaching-service": {
        "page_title": "Tennis Stringing & Coaching Elevate Your Game",
        "banner_image": tennisRepairBanner,
        "full_description": "Professional stringing services and personalized coaching to enhance your performance on the court.",
        "offer_description": "Comprehensive tennis services for players of all levels.",
        "offers": [
            { "image": tennisOffer1, "title": "Racquet Stringing", "description": "Precision stringing tailored to your playing style." },
            { "image": tennisOffer2, "title": "Grip Replacement", "description": "Ensuring optimal comfort and control." },
            { "image": tennisOffer3, "title": "Private Coaching", "description": "One-on-one sessions focusing on technique and strategy." },
            { "image": tennisOffer4, "title": "Group Clinics", "description": "Collaborative training sessions for skill development." },
            { "image": tennisOffer5, "title": "Match Analysis", "description": "Reviewing gameplay to identify areas for improvement." },
        ],
        "process_steps": [
            { "title": "Consultation", "description": "Understanding your needs and goals." },
            { "title": "Service Execution", "description": "Performing stringing or coaching sessions as per plan." },
            { "title": "Feedback & Adjustment", "description": "Gathering your input to refine our services." },
            { "title": "Follow-Up", "description": "Ongoing support to track progress and make improvements." }
        ],
        "personImage": tennisPersonImage,
        "why_choose": [
            { "icon": tennisIcon1, "title": "Certified Professionals", "description": "Experienced stringers and coaches with a passion for tennis." },
            { "icon": tennisIcon2, "title": "Customized Services", "description": "Tailored solutions to meet individual player needs." },
            { "icon": tennisIcon3, "title": "Quality Equipment", "description": "Utilizing top-tier tools and materials." },
            { "icon": tennisIcon4, "title": "Flexible Scheduling", "description": "Sessions arranged to fit your availability." },
        ],
        "title": "Tennis Stringing & Coaching",
        "short_description": "Precision stringing and personal coaching for players of all levels.",
        "image": service5,
        "link": "/services/tennis-coaching-service"
    },
}